import { TimeRangeValue } from '@chronosphereio/core';

export const DEFAULT_TIME_RANGE: TimeRangeValue = { pastDuration: '1h' };
